import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import './MainLayout.css';

const { Content } = Layout;

const MainLayout = () => {
  return (
    <Layout className="main-layout">
      <Content className="main-content">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default MainLayout; 